'use strict';

angular.module('kerp-forms.forms').config(['schemaFormDecoratorsProvider', 'sfBuilderProvider',
  function (schemaFormDecoratorsProvider, sfBuilderProvider) {

    schemaFormDecoratorsProvider.defineAddOn(
      // Name of the decorator you want to add to
      'bootstrapDecorator',

      // Form type that should render this add-on
      'validationExternal',

      // Template name in $templateCache
      'modules/forms/scripts/directives/validationExternal/validationExternal.html',

      // List of builder functions to apply
      sfBuilderProvider.stdBuilders
    );
  }]);
